import styled from 'styled-components';

import { breakpoint } from '@/themes/breakpoints';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${breakpoint.md} {
    width: 846px;
  }

  @media ${breakpoint.lg} {
    width: 868px;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: flex-start;
  gap: 24px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 12px;
`;
